import { render } from "./AlbumsView.vue?vue&type=template&id=eef72f9c&scoped=true"
import script from "./AlbumsView.vue?vue&type=script&lang=js"
export * from "./AlbumsView.vue?vue&type=script&lang=js"

import "./AlbumsView.vue?vue&type=style&index=0&id=eef72f9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef72f9c"]])

export default __exports__